import { useState } from "react";
import { toast } from "sonner";
import { BookmarkPlus, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { useEditor } from "./useEditorState";
import { errMsg } from "@/lib/api";

export default function SaveBlockButton({ section }) {
  const ed = useEditor();
  const [open, setOpen] = useState(false);
  const [name, setName] = useState(section.name);
  const [category, setCategory] = useState("Le mie sezioni");
  const [keep, setKeep] = useState(false);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      const { data } = await ed.api.post("/library/my-blocks", { name, category, section, source_project_id: ed.id, keep_client_images: keep });
      toast.success(data.replaced_images ? `Salvata nella libreria (${data.replaced_images} foto del cliente sostituite con foto stock)` : "Sezione salvata nella libreria");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <>
      <Button size="sm" variant="outline" className="h-8 text-xs w-full" onClick={() => { setName(section.name); setKeep(false); setOpen(true); }} data-testid="props-save-block-btn"><BookmarkPlus size={13} className="mr-1" />Salva nella libreria</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-md" data-testid="save-block-dialog">
          <DialogHeader>
            <DialogTitle>Salva sezione nella libreria</DialogTitle>
            <DialogDescription>Potrai riutilizzarla in qualsiasi progetto da «Aggiungi sezione → Le mie sezioni».</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nome" data-testid="save-block-name-input" />
            <Input value={category} onChange={(e) => setCategory(e.target.value)} placeholder="Categoria (es. Hero, Prezzi, Prenotazione)" data-testid="save-block-category-input" />
            <label className="flex items-start justify-between gap-3 text-sm text-slate-700">
              <span>Includi le foto caricate dal cliente<span className="block text-[11px] text-slate-500">Solo se il cliente ha autorizzato il riutilizzo. Altrimenti vengono sostituite con foto stock gratuite.</span></span>
              <Switch checked={keep} onCheckedChange={setKeep} data-testid="save-block-keep-images-switch" />
            </label>
          </div>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setOpen(false)}>Annulla</Button>
            <Button onClick={save} disabled={busy || !name.trim()} data-testid="save-block-confirm-btn">{busy && <Loader2 size={14} className="mr-1.5 animate-spin" />}Salva</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
